import { app } from '../../env'
import { NewUserPromoDetail, NEW_USER_PROMO_MERCHANTS, QA_NEW_USER_PROMO_MERCHANTS } from './constants'

export const getNewUserPromoMerchants = (): Record<number, NewUserPromoDetail> => {
  const { APP_ENVIRONMENT } = app
  switch (APP_ENVIRONMENT) {
    case 'au-prod':
    case 'us-prod':
      return NEW_USER_PROMO_MERCHANTS
    default:
      return QA_NEW_USER_PROMO_MERCHANTS
  }
}
